import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AppActions from '../../actions/app-actions';
import { preformatWithRequestID } from '../../helpers';

import Form from '../common/forms/form';
import TextInput from '../common/forms/textinput';

const Password = () => {
  const [confirm, setConfirm] = useState(false);

  const _handleSubmit = formData => {
    if (!formData.hasOwnProperty('email')) {
      return;
    }

    AppActions.forgotpwd(formData)
      .then(() => {
        setConfirm(true);
      })
      .catch(err => {
        var errMsg = 'Error';
        if (err.res.body && Object.keys(err.res.body).includes('error')) {
          errMsg = `${errMsg}: ${err.res.body['error']}`;
        }
        AppActions.setSnackbar(preformatWithRequestID(err.res, errMsg), null, 'Copy to clipboard');
      });
  };

  return (
    <div className="full-screen">
      <div className="flexbox column" id="login-box">
        <img src="assets/img/1-edgeway_logo_rgb.png" alt="loginlogo.png" className="margin-bottom-small" id="edgeWayLogo" />
        <h1 className="align-center">Reset your password</h1>
        {
          confirm ? (
            <p className="margin-bottom align-center">
              Thanks - we&#39;re sending you an email now!
              <br />
            If there is an account with that address, you&#39;ll receive an email with a link and instructions to reset your password.
            </p>
          ) : (
              <>
                <p className="margin-bottom align-center">
                  If you&#39;ve forgotten your password, you can request to reset it.
                  <br />
              Enter the email address you use to sign in to EdgeWay, and we&#39;ll send you a reset link.
                </p>
                <Form
                  showButtons={true}
                  buttonColor="primary"
                  onSubmit={formdata => _handleSubmit(formdata)}
                  submitLabel="Send the password reset link"
                  submitButtonId="password_button"
                >
                  <TextInput hint="Your email" label="Your email" id="email" required={true} validations="isLength:1,isEmail" />
                </Form>
              </>
          )}
        <div className="margin-top-large text-muted">
          <div className="flexbox centered">
            <Link style={{ marginLeft: '4px' }} to="/login">
              Back to the login page
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Password;
